import styled from 'styled-components';
import { motion } from 'framer-motion';
import { CAMERA_CONFIG } from './cameraConfig';

export const CameraContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  cursor: ${props => props.isPanning ? 'grabbing' : 'grab'};
  user-select: none;
  touch-action: none; /* Prevent default touch behaviors */
  -webkit-touch-callout: none; /* Disable callout on iOS */
  -webkit-user-select: none; /* Disable text selection on iOS */
`;

export const WorldContainer = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: 0 0;
  will-change: transform;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
`;

export const NodeWrapper = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  /* Suspended while zooming: WebKit folds the CSS zoom property into the
     computed left/top of descendants, so the zoom<->transform render mode
     switch makes these values jump by the scale factor. With a transition
     active, that jump animates and the cards visually freeze during the
     pinch, then drift back into place afterwards (iOS-only bug). */
  transition: ${props => props.$suspendTransition
    ? 'none'
    : `left ${CAMERA_CONFIG.NODE_TRANSITION_DURATION}ms ${CAMERA_CONFIG.NODE_TRANSITION_EASING},
       top ${CAMERA_CONFIG.NODE_TRANSITION_DURATION}ms ${CAMERA_CONFIG.NODE_TRANSITION_EASING},
       opacity ${CAMERA_CONFIG.NODE_TRANSITION_DURATION}ms ${CAMERA_CONFIG.NODE_TRANSITION_EASING}`};
  opacity: ${props => props.$visible ? 1 : 0};
  z-index: 2;
`;
